import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'gogo_admin_token';

export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Public
export const fetchApps = async (listType) => {
  const params = listType ? { listType } : {};
  const { data } = await axios.get(`${API}/apps`, { params });
  return data;
};

export const fetchApp = async (slug) => {
  const { data } = await axios.get(`${API}/apps/${slug}`);
  return data;
};

export const fetchSettings = async () => {
  const { data } = await axios.get(`${API}/settings`);
  return data;
};

// Admin
export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  setToken(data.token);
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return data;
};

export const createApp = async (payload) => {
  const { data } = await axios.post(`${API}/admin/apps`, payload, { headers: authHeaders() });
  return data;
};

export const bulkCreate = async (apps) => {
  const { data } = await axios.post(`${API}/admin/apps/bulk`, { apps }, { headers: authHeaders() });
  return data;
};

export const updateApp = async (id, payload) => {
  const { data } = await axios.put(`${API}/admin/apps/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deleteApp = async (id) => {
  const { data } = await axios.delete(`${API}/admin/apps/${id}`, { headers: authHeaders() });
  return data;
};

export const moveApp = async (id, direction) => {
  const { data } = await axios.post(
    `${API}/admin/apps/${id}/move?direction=${direction}`,
    {},
    { headers: authHeaders() },
  );
  return data;
};

export const updateSettings = async (payload) => {
  const { data } = await axios.put(`${API}/admin/settings`, payload, { headers: authHeaders() });
  return data;
};
